var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 421,
    height: 93,
    viewBox: "0 0 421 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_108",
    "data-name": "\\uD328\\uC2A4 108",
    d: "M462.616,129v28.7a215.9,215.9,0,0,0-22.818,1.931V130.445a30.532,30.532,0,0,1,3.577-1.816",
    transform: "translate(-439.798 -128.629)",
    fill: "#fff",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_36",
    "data-name": "\\uC0AC\\uAC01\\uD615 36",
    width: 946.137,
    height: 3985.604,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_110",
    "data-name": "\\uD328\\uC2A4 110",
    d: "M478.223,129l19.241-.372a30.539,30.539,0,0,1,3.577,1.816v29.183a215.9,215.9,0,0,0-22.818-1.931Z",
    transform: "translate(-478.223 -128.629)",
    fill: "#fff",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_112",
    "data-name": "\\uD328\\uC2A4 112",
    d: "M445.668,126.572q8.938-4.675,19.332,0v26.7a24.466,24.466,0,0,0-19.332,0Z",
    transform: "translate(-445.668 -124.234)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_40",
    "data-name": "\\uC0AC\\uAC01\\uD615 40",
    width: 946.137,
    height: 3985.604,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_114",
    "data-name": "\\uD328\\uC2A4 114",
    d: "M478.223,126.572q8.939-4.675,19.332,0v26.7a24.466,24.466,0,0,0-19.332,0Z",
    transform: "translate(-478.223 -124.234)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_120",
    "data-name": "\\uD328\\uC2A4 120",
    d: "M455.808,138.034l3.328-5.009,3.328,5.009v24.685h-6.655Z",
    transform: "translate(-455.808 -133.026)",
    fill: "#fff",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_47",
    "data-name": "\\uC0AC\\uAC01\\uD615 47",
    width: 6.655,
    height: 4.242,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_88",
    "data-name": "\\uD328\\uC2A4 88",
    d: "M116.555,123.781h23.607v5.3h4.92v28.69H116.555Z",
    transform: "translate(-116.555 -123.781)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86",
    "data-name": "\\uD328\\uC2A4 86",
    d: "M158.861,128.96l-4.755-5.179-3.628,7.922Z",
    transform: "translate(-150.479 -123.781)",
    fill: "#fff",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_100",
    "data-name": "\\uD328\\uC2A4 100",
    d: "M332.5,141.171h0V158.2l-8.08-5.284a14,14,0,0,1-5.5,1.113A13.046,13.046,0,1,1,332.5,141C332.5,141.055,332.5,141.113,332.5,141.171Z",
    transform: "translate(-305.345 -127.961)",
    fill: "#fff",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_102",
    "data-name": "\\uD328\\uC2A4 102",
    d: "M274.613,152.919l-8.08,5.284V141.17h0c0-.058,0-.116,0-.175a13.587,13.587,0,1,1,13.576,13.036A14,14,0,0,1,274.613,152.919Z",
    transform: "translate(-266.533 -127.961)",
    fill: "#fff",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_106",
    "data-name": "\\uD328\\uC2A4 106",
    d: "M288.963,159.38a.651.651,0,1,0-.631-.651A.642.642,0,0,0,288.963,159.38Z",
    transform: "translate(-288.332 -158.079)",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3521",
    "data-name": "\\uADF8\\uB8F9 3521",
    transform: "translate(-752 -878)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uBA74\\uC811\\uC2EC\\uC0AC",
    transform: "translate(853 968)",
    fontSize: 11,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uBA74\uC811\uC2EC\uC0AC")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC804\\uBB38\\uAD50\\uC721",
    transform: "translate(942 968)",
    fontSize: 11,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC804\uBB38\uAD50\uC721")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC11C\\uB958\\uC81C\\uCD9C",
    transform: "translate(1029 968)",
    fontSize: 11,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC11C\uB958\uC81C\uCD9C")), /*#__PURE__*/React.createElement("text", {
    id: "\\uD65C\\uB3D9\\uAC00\\uB2A5",
    transform: "translate(1116 968)",
    fontSize: 11,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD65C\uB3D9\uAC00\uB2A5")), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2021",
    "data-name": "\\uADF8\\uB8F9 2021",
    transform: "translate(927.562 877.747)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_195",
    "data-name": "\\uD0C0\\uC6D0 195",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(0.438 0.253)",
    fill: "rgba(246,159,48,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2006",
    "data-name": "\\uADF8\\uB8F9 2006",
    transform: "translate(11.661 17.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_289",
    "data-name": "\\uADF8\\uB8F9 289",
    transform: "translate(0.739 3.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_288",
    "data-name": "\\uADF8\\uB8F9 288",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_287",
    "data-name": "\\uADF8\\uB8F9 287",
    transform: "translate(-350.213 -1865.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_286",
    "data-name": "\\uADF8\\uB8F9 286",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_285",
    "data-name": "\\uADF8\\uB8F9 285",
    transform: "translate(346.517 1862.075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_35",
    "data-name": "\\uC0AC\\uAC01\\uD615 35",
    width: 30.21,
    height: 38.39,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_291",
    "data-name": "\\uADF8\\uB8F9 291",
    transform: "translate(0 2.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_290",
    "data-name": "\\uADF8\\uB8F9 290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_109",
    "data-name": "\\uD328\\uC2A4 109",
    d: "M439.292,159.861a.739.739,0,0,1-.739-.739V129.939a.739.739,0,0,1,.363-.637,31.5,31.5,0,0,1,3.664-1.859.739.739,0,1,1,.578,1.36,29.841,29.841,0,0,0-3.128,1.56V158.29l1.167-.139a201.68,201.68,0,0,1,20.173-1.683V128.5a.739.739,0,1,1,1.479,0v28.7a.74.74,0,0,1-.726.739,196.348,196.348,0,0,0-20.75,1.688l-1.995.238A.719.719,0,0,1,439.292,159.861Z",
    transform: "translate(-438.553 -127.384)",
    fill: "#434343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_296",
    "data-name": "\\uADF8\\uB8F9 296",
    transform: "translate(23.557 3.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_295",
    "data-name": "\\uADF8\\uB8F9 295",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_294",
    "data-name": "\\uADF8\\uB8F9 294",
    transform: "translate(-373.03 -1865.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_293",
    "data-name": "\\uADF8\\uB8F9 293",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_292",
    "data-name": "\\uADF8\\uB8F9 292",
    transform: "translate(369.335 1862.075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_37",
    "data-name": "\\uC0AC\\uAC01\\uD615 37",
    width: 30.21,
    height: 38.39,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_298",
    "data-name": "\\uADF8\\uB8F9 298",
    transform: "translate(22.818 2.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_297",
    "data-name": "\\uADF8\\uB8F9 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_111",
    "data-name": "\\uD328\\uC2A4 111",
    d: "M500.535,159.861a.716.716,0,0,1-.087-.005l-1.993-.238A196.526,196.526,0,0,0,477.7,157.93a.74.74,0,0,1-.726-.739V128.5a.739.739,0,0,1,.725-.739l19.24-.372a.783.783,0,0,1,.3.059,31.446,31.446,0,0,1,3.664,1.859.737.737,0,0,1,.363.637v29.183a.739.739,0,0,1-.739.739Zm-22.079-3.394a201.686,201.686,0,0,1,20.174,1.683l1.166.139V130.364a29.863,29.863,0,0,0-2.983-1.5l-18.357.355Z",
    transform: "translate(-476.978 -127.384)",
    fill: "#434343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_303",
    "data-name": "\\uADF8\\uB8F9 303",
    transform: "translate(4.225 0.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_302",
    "data-name": "\\uADF8\\uB8F9 302",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_301",
    "data-name": "\\uADF8\\uB8F9 301",
    transform: "translate(-353.699 -1863.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_300",
    "data-name": "\\uADF8\\uB8F9 300",
    transform: "translate(0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_299",
    "data-name": "\\uADF8\\uB8F9 299",
    transform: "translate(350.003 1859.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_39",
    "data-name": "\\uC0AC\\uAC01\\uD615 39",
    width: 26.724,
    height: 36.432,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_305",
    "data-name": "\\uADF8\\uB8F9 305",
    transform: "translate(3.486 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_304",
    "data-name": "\\uADF8\\uB8F9 304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_113",
    "data-name": "\\uD328\\uC2A4 113",
    d: "M464.495,153.514a.739.739,0,0,1-.281-.056,23.849,23.849,0,0,0-18.769,0,.739.739,0,0,1-1.02-.683v-26.7a.739.739,0,0,1,.4-.655c6.143-3.213,12.863-3.219,19.977-.019a.74.74,0,0,1,.436.674v26.7a.741.741,0,0,1-.739.739Zm-9.666-3.462a25.646,25.646,0,0,1,8.926,1.641V126.554c-6.363-2.746-12.366-2.755-17.853-.029v25.168A25.649,25.649,0,0,1,454.829,150.052Z",
    transform: "translate(-444.424 -123.002)",
    fill: "#434343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_310",
    "data-name": "\\uADF8\\uB8F9 310",
    transform: "translate(23.557 0.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_309",
    "data-name": "\\uADF8\\uB8F9 309",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_308",
    "data-name": "\\uADF8\\uB8F9 308",
    transform: "translate(-373.03 -1863.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_307",
    "data-name": "\\uADF8\\uB8F9 307",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_306",
    "data-name": "\\uADF8\\uB8F9 306",
    transform: "translate(369.335 1859.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_41",
    "data-name": "\\uC0AC\\uAC01\\uD615 41",
    width: 26.724,
    height: 36.432,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_316",
    "data-name": "\\uADF8\\uB8F9 316",
    transform: "translate(22.818 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_311",
    "data-name": "\\uADF8\\uB8F9 311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_115",
    "data-name": "\\uD328\\uC2A4 115",
    d: "M477.717,153.514a.741.741,0,0,1-.739-.739v-26.7a.74.74,0,0,1,.4-.655c6.143-3.213,12.864-3.219,19.978-.019a.739.739,0,0,1,.436.674v26.7a.739.739,0,0,1-1.02.683,23.85,23.85,0,0,0-18.769,0A.735.735,0,0,1,477.717,153.514Zm9.666-3.462a25.653,25.653,0,0,1,8.927,1.641V126.554c-6.363-2.745-12.365-2.755-17.854-.029v25.168A25.649,25.649,0,0,1,487.384,150.052Z",
    transform: "translate(-476.978 -123.002)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_312",
    "data-name": "\\uADF8\\uB8F9 312",
    transform: "translate(3.803 5.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_116",
    "data-name": "\\uD328\\uC2A4 116",
    d: "M495.214,134.242a.745.745,0,0,1-.234-.039,15.927,15.927,0,0,0-10.61-.05.739.739,0,1,1-.5-1.393,17.364,17.364,0,0,1,11.574.041.739.739,0,0,1-.234,1.441Z",
    transform: "translate(-483.382 -131.788)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_313",
    "data-name": "\\uADF8\\uB8F9 313",
    transform: "translate(3.803 10.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117",
    "data-name": "\\uD328\\uC2A4 117",
    d: "M495.214,143.582a.728.728,0,0,1-.234-.039,15.927,15.927,0,0,0-10.61-.05.739.739,0,0,1-.5-1.393,17.36,17.36,0,0,1,11.574.041.739.739,0,0,1-.234,1.44Z",
    transform: "translate(-483.382 -141.128)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_314",
    "data-name": "\\uADF8\\uB8F9 314",
    transform: "translate(3.803 16.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118",
    "data-name": "\\uD328\\uC2A4 118",
    d: "M495.214,153.473a.746.746,0,0,1-.234-.039,15.923,15.923,0,0,0-10.61-.05.739.739,0,1,1-.5-1.393,17.357,17.357,0,0,1,11.574.041.739.739,0,0,1-.234,1.441Z",
    transform: "translate(-483.382 -151.019)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_315",
    "data-name": "\\uADF8\\uB8F9 315",
    transform: "translate(3.803 22.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_119",
    "data-name": "\\uD328\\uC2A4 119",
    d: "M495.214,163.364a.729.729,0,0,1-.234-.039,15.93,15.93,0,0,0-10.61-.05.739.739,0,0,1-.5-1.393,17.364,17.364,0,0,1,11.574.041.739.739,0,0,1-.234,1.44Z",
    transform: "translate(-483.382 -160.911)",
    fill: "#434343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_321",
    "data-name": "\\uADF8\\uB8F9 321",
    transform: "translate(10.247 5.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_320",
    "data-name": "\\uADF8\\uB8F9 320",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_319",
    "data-name": "\\uADF8\\uB8F9 319",
    transform: "translate(-359.72 -1868.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_318",
    "data-name": "\\uADF8\\uB8F9 318",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_317",
    "data-name": "\\uADF8\\uB8F9 317",
    transform: "translate(356.024 1864.685)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_43",
    "data-name": "\\uC0AC\\uAC01\\uD615 43",
    width: 14.047,
    height: 37.085,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_323",
    "data-name": "\\uADF8\\uB8F9 323",
    transform: "translate(9.507 5.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_322",
    "data-name": "\\uADF8\\uB8F9 322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121",
    "data-name": "\\uD328\\uC2A4 121",
    d: "M461.958,162.967H455.3a.739.739,0,0,1-.739-.739V137.543a.741.741,0,0,1,.124-.409l3.328-5.009a.767.767,0,0,1,1.232,0l3.328,5.009a.74.74,0,0,1,.124.409v24.685A.739.739,0,0,1,461.958,162.967Zm-5.916-1.478h5.177V137.766l-2.588-3.9-2.588,3.9Z",
    transform: "translate(-454.563 -131.816)",
    fill: "#484848"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_328",
    "data-name": "\\uADF8\\uB8F9 328",
    transform: "translate(10.247 31.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_327",
    "data-name": "\\uADF8\\uB8F9 327",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_326",
    "data-name": "\\uADF8\\uB8F9 326",
    transform: "translate(-359.72 -1893.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_325",
    "data-name": "\\uADF8\\uB8F9 325",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_324",
    "data-name": "\\uADF8\\uB8F9 324",
    transform: "translate(356.024 1890.136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_45",
    "data-name": "\\uC0AC\\uAC01\\uD615 45",
    width: 14.047,
    height: 11.634,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_330",
    "data-name": "\\uADF8\\uB8F9 330",
    transform: "translate(9.507 30.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_329",
    "data-name": "\\uADF8\\uB8F9 329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_122",
    "data-name": "\\uD328\\uC2A4 122",
    d: "M461.958,180.361H455.3a.74.74,0,0,1-.739-.739V175.38a.739.739,0,0,1,.739-.739h6.656a.739.739,0,0,1,.739.739v4.242A.74.74,0,0,1,461.958,180.361Zm-5.916-1.479h5.177v-2.764h-5.177Z",
    transform: "translate(-454.563 -174.641)",
    fill: "#484848"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2022",
    "data-name": "\\uADF8\\uB8F9 2022",
    transform: "translate(1015.78 877.747)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_196",
    "data-name": "\\uD0C0\\uC6D0 196",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(0.22 0.253)",
    fill: "rgba(246,159,48,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2015",
    "data-name": "\\uADF8\\uB8F9 2015",
    transform: "translate(17.604 14.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2012",
    "data-name": "\\uADF8\\uB8F9 2012",
    transform: "translate(0.739 6.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_236",
    "data-name": "\\uADF8\\uB8F9 236",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_235",
    "data-name": "\\uADF8\\uB8F9 235",
    transform: "translate(-158.264 -1862.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_234",
    "data-name": "\\uADF8\\uB8F9 234",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_233",
    "data-name": "\\uADF8\\uB8F9 233",
    transform: "translate(154.568 1859.196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_23",
    "data-name": "\\uC0AC\\uAC01\\uD615 23",
    width: 35.919,
    height: 41.382,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2011",
    "data-name": "\\uADF8\\uB8F9 2011",
    transform: "translate(0 5.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_238",
    "data-name": "\\uADF8\\uB8F9 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_89",
    "data-name": "\\uD328\\uC2A4 89",
    d: "M144.576,158H116.049a.739.739,0,0,1-.739-.739v-33.99a.739.739,0,0,1,.739-.739h23.607a.739.739,0,0,1,.739.739v4.561h4.181a.74.74,0,0,1,.739.739v28.69A.739.739,0,0,1,144.576,158Zm-27.788-1.478h27.049V129.315h-4.181a.739.739,0,0,1-.739-.739v-4.561H116.788Z",
    transform: "translate(-115.31 -122.536)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_239",
    "data-name": "\\uADF8\\uB8F9 239",
    transform: "translate(6.023 9.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_90",
    "data-name": "\\uD328\\uC2A4 90",
    d: "M143.308,140.1H126.191a.739.739,0,0,1,0-1.479h17.117a.739.739,0,0,1,0,1.479Z",
    transform: "translate(-125.452 -138.618)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_240",
    "data-name": "\\uADF8\\uB8F9 240",
    transform: "translate(6.023 18.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_91",
    "data-name": "\\uD328\\uC2A4 91",
    d: "M133.8,155.361h-7.608a.739.739,0,0,1,0-1.479H133.8a.739.739,0,0,1,0,1.479Z",
    transform: "translate(-125.452 -153.882)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_241",
    "data-name": "\\uADF8\\uB8F9 241",
    transform: "translate(6.023 23.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_92",
    "data-name": "\\uD328\\uC2A4 92",
    d: "M133.8,162.993h-7.608a.739.739,0,0,1,0-1.478H133.8a.739.739,0,0,1,0,1.478Z",
    transform: "translate(-125.452 -161.515)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_242",
    "data-name": "\\uADF8\\uB8F9 242",
    transform: "translate(6.023 14.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_93",
    "data-name": "\\uD328\\uC2A4 93",
    d: "M137.285,147.729H126.191a.739.739,0,0,1,0-1.479h11.094a.739.739,0,1,1,0,1.479Z",
    transform: "translate(-125.452 -146.25)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_243",
    "data-name": "\\uADF8\\uB8F9 243",
    transform: "translate(6.023 27.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_94",
    "data-name": "\\uD328\\uC2A4 94",
    d: "M136.334,170.625H126.191a.739.739,0,0,1,0-1.479h10.143a.739.739,0,0,1,0,1.479Z",
    transform: "translate(-125.452 -169.146)",
    fill: "#434343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_230",
    "data-name": "\\uADF8\\uB8F9 230",
    transform: "translate(25.583 0.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_229",
    "data-name": "\\uADF8\\uB8F9 229",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_228",
    "data-name": "\\uADF8\\uB8F9 228",
    transform: "translate(-178.409 -1862.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_227",
    "data-name": "\\uADF8\\uB8F9 227",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_226",
    "data-name": "\\uADF8\\uB8F9 226",
    transform: "translate(174.713 1859.196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_21",
    "data-name": "\\uC0AC\\uAC01\\uD615 21",
    width: 15.774,
    height: 15.314,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_232",
    "data-name": "\\uADF8\\uB8F9 232",
    transform: "translate(24.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_231",
    "data-name": "\\uADF8\\uB8F9 231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_87",
    "data-name": "\\uD328\\uC2A4 87",
    d: "M149.973,131.937a.739.739,0,0,1-.672-1.047l3.628-7.923a.739.739,0,0,1,1.217-.192l4.754,5.18a.739.739,0,0,1-.315,1.2L150.2,131.9A.729.729,0,0,1,149.973,131.937Zm3.837-7.341-2.461,5.375,5.687-1.861Z",
    transform: "translate(-149.234 -122.536)",
    fill: "#434343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_237",
    "data-name": "\\uADF8\\uB8F9 237",
    transform: "translate(5.438 0.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_236-2",
    "data-name": "\\uADF8\\uB8F9 236",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_235-2",
    "data-name": "\\uADF8\\uB8F9 235",
    transform: "translate(-158.264 -1862.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_234-2",
    "data-name": "\\uADF8\\uB8F9 234",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_233-2",
    "data-name": "\\uADF8\\uB8F9 233",
    transform: "translate(154.568 1859.196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_23-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 23",
    width: 35.919,
    height: 41.382,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_238-2",
    "data-name": "\\uADF8\\uB8F9 238",
    transform: "translate(4.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_89-2",
    "data-name": "\\uD328\\uC2A4 89",
    d: "M144.576,158H116.049a.739.739,0,0,1-.739-.739v-33.99a.739.739,0,0,1,.739-.739h23.607a.739.739,0,0,1,.739.739v4.561h4.181a.74.74,0,0,1,.739.739v28.69A.739.739,0,0,1,144.576,158Zm-27.788-1.478h27.049V129.315h-4.181a.739.739,0,0,1-.739-.739v-4.561H116.788Z",
    transform: "translate(-115.31 -122.536)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_239-2",
    "data-name": "\\uADF8\\uB8F9 239",
    transform: "translate(10.722 18.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_90-2",
    "data-name": "\\uD328\\uC2A4 90",
    d: "M143.308,140.1H126.191a.739.739,0,0,1,0-1.479h17.117a.739.739,0,0,1,0,1.479Z",
    transform: "translate(-125.452 -138.618)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2013",
    "data-name": "\\uADF8\\uB8F9 2013",
    transform: "translate(10.722 22.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_90-3",
    "data-name": "\\uD328\\uC2A4 90",
    d: "M143.308,140.1H126.191a.739.739,0,0,1,0-1.479h17.117a.739.739,0,0,1,0,1.479Z",
    transform: "translate(-125.452 -138.618)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2014",
    "data-name": "\\uADF8\\uB8F9 2014",
    transform: "translate(10.722 27.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_90-4",
    "data-name": "\\uD328\\uC2A4 90",
    d: "M143.308,140.1H126.191a.739.739,0,0,1,0-1.479h17.117a.739.739,0,0,1,0,1.479Z",
    transform: "translate(-125.452 -138.618)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_1078",
    "data-name": "\\uD328\\uC2A4 1078",
    transform: "translate(10.847 5.313)",
    fill: "#fff",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.864894866943359 9.431236267089844 L 0.7500050663948059 9.431236267089844 L 0.7500050663948059 0.7499967217445374 L 7.864894866943359 0.7499967217445374 L 7.864894866943359 9.431236267089844 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.499995231628418 1.499997138977051 L 1.499995231628418 8.681236267089844 L 7.114885330200195 8.681236267089844 L 7.114885330200195 1.499997138977051 L 1.499995231628418 1.499997138977051 M -4.76837158203125e-06 -2.86102294921875e-06 L 8.614885330200195 -2.86102294921875e-06 L 8.614885330200195 10.18123626708984 L -4.76837158203125e-06 10.18123626708984 L -4.76837158203125e-06 -2.86102294921875e-06 Z",
    stroke: "none",
    fill: "#434343"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2020",
    "data-name": "\\uADF8\\uB8F9 2020",
    transform: "translate(840.218 877.747)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_194",
    "data-name": "\\uD0C0\\uC6D0 194",
    cx: 35.5,
    cy: 35,
    rx: 35.5,
    ry: 35,
    transform: "translate(-0.218 0.253)",
    fill: "rgba(246,159,48,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2018",
    "data-name": "\\uADF8\\uB8F9 2018",
    transform: "translate(9.512 19.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2005",
    "data-name": "\\uADF8\\uB8F9 2005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_265",
    "data-name": "\\uADF8\\uB8F9 265",
    transform: "translate(23.787 0.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_264",
    "data-name": "\\uADF8\\uB8F9 264",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_263",
    "data-name": "\\uADF8\\uB8F9 263",
    transform: "translate(-270.372 -1865.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_262",
    "data-name": "\\uADF8\\uB8F9 262",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_261",
    "data-name": "\\uADF8\\uB8F9 261",
    transform: "translate(266.676 1861.678)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_29",
    "data-name": "\\uC0AC\\uAC01\\uD615 29",
    width: 34.544,
    height: 37.633,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_267",
    "data-name": "\\uADF8\\uB8F9 267",
    transform: "translate(23.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_266",
    "data-name": "\\uADF8\\uB8F9 266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_101",
    "data-name": "\\uD328\\uC2A4 101",
    d: "M331.992,158.437a.74.74,0,0,1-.4-.121l-7.754-5.071a14.7,14.7,0,0,1-5.417,1.02c-7.893,0-14.315-6.179-14.315-13.775s6.422-13.774,14.315-13.774,14.315,6.179,14.315,13.774v.138c0,.012,0,.024,0,.036V157.7a.739.739,0,0,1-.739.739Zm-8.08-6.762a.742.742,0,0,1,.4.121l6.936,4.536V140.706c0-.016,0-.033,0-.049v-.167a12.849,12.849,0,1,0-12.837,12.3,13.217,13.217,0,0,0,5.207-1.053A.733.733,0,0,1,323.912,151.674Z",
    transform: "translate(-304.101 -126.716)",
    fill: "#434343"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_272",
    "data-name": "\\uADF8\\uB8F9 272",
    transform: "translate(0.739 0.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_271",
    "data-name": "\\uADF8\\uB8F9 271",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_270",
    "data-name": "\\uADF8\\uB8F9 270",
    transform: "translate(-247.325 -1865.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_269",
    "data-name": "\\uADF8\\uB8F9 269",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_268",
    "data-name": "\\uADF8\\uB8F9 268",
    transform: "translate(243.629 1861.678)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31",
    "data-name": "\\uC0AC\\uAC01\\uD615 31",
    width: 34.544,
    height: 37.633,
    transform: "translate(0 0)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_276",
    "data-name": "\\uADF8\\uB8F9 276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_273",
    "data-name": "\\uADF8\\uB8F9 273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_103",
    "data-name": "\\uD328\\uC2A4 103",
    d: "M266.027,158.437a.74.74,0,0,1-.739-.739V140.664c0-.012,0-.024,0-.036v-.138c0-7.595,6.422-13.774,14.315-13.774s14.315,6.179,14.315,13.774S287.5,154.265,279.6,154.265a14.691,14.691,0,0,1-5.417-1.02l-7.755,5.071A.737.737,0,0,1,266.027,158.437Zm.739-17.731v15.625l6.936-4.536a.739.739,0,0,1,.694-.061,13.221,13.221,0,0,0,5.207,1.053,12.308,12.308,0,1,0-12.837-12.3v.167C266.767,140.673,266.767,140.69,266.767,140.706Z",
    transform: "translate(-265.288 -126.716)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_274",
    "data-name": "\\uADF8\\uB8F9 274",
    transform: "translate(30.309 7.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_104",
    "data-name": "\\uD328\\uC2A4 104",
    d: "M322.178,151.743a.739.739,0,0,1-.52-.214l-5.11-5.066a.739.739,0,1,1,1.041-1.049l4.508,4.47,7.326-9.73a.739.739,0,1,1,1.181.89l-7.835,10.406a.738.738,0,0,1-.537.293Z",
    transform: "translate(-316.329 -139.858)",
    fill: "#484848"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_281",
    "data-name": "\\uADF8\\uB8F9 281",
    transform: "translate(13.684 18.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_280",
    "data-name": "\\uADF8\\uB8F9 280",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_279",
    "data-name": "\\uADF8\\uB8F9 279",
    transform: "translate(-260.269 -1883.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_278",
    "data-name": "\\uADF8\\uB8F9 278",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_277",
    "data-name": "\\uADF8\\uB8F9 277",
    transform: "translate(256.573 1879.563)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_33",
    "data-name": "\\uC0AC\\uAC01\\uD615 33",
    width: 8.655,
    height: 8.693,
    transform: "translate(0 0)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_988",
    "data-name": "\\uD328\\uC2A4 988",
    d: "M5551.892-5961.5h10.977",
    transform: "translate(-5543.298 5971.473)",
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_989",
    "data-name": "\\uD328\\uC2A4 989",
    d: "M5551.892-5961.5h10.977",
    transform: "translate(-5543.298 5975.389)",
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_990",
    "data-name": "\\uD328\\uC2A4 990",
    d: "M5551.892-5961.5h8.081",
    transform: "translate(-5543.298 5979.304)",
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\uC815\\uBCF4\\uAE30\\uC785",
    transform: "translate(766 968)",
    fontSize: 11,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC815\uBCF4\uAE30\uC785")), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2024",
    "data-name": "\\uADF8\\uB8F9 2024",
    transform: "translate(752 877.747)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_193",
    "data-name": "\\uD0C0\\uC6D0 193",
    cx: 35.5,
    cy: 35,
    rx: 35.5,
    ry: 35,
    transform: "translate(0 0.253)",
    fill: "rgba(246,159,48,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2017",
    "data-name": "\\uADF8\\uB8F9 2017",
    transform: "translate(20.016 17.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2016",
    "data-name": "\\uADF8\\uB8F9 2016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_763",
    "data-name": "\\uD328\\uC2A4 763",
    d: "M628,235v36.074h28.647V243.915L647.825,235Z",
    transform: "translate(-628 -235)",
    fill: "#fff",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1479",
    "data-name": "\\uADF8\\uB8F9 1479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_763-2",
    "data-name": "\\uD328\\uC2A4 763",
    d: "M628,235v36.074h28.647V243.915L647.825,235Z",
    transform: "translate(-628 -235)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_764",
    "data-name": "\\uD328\\uC2A4 764",
    d: "M664.479,236v8.5h9.284",
    transform: "translate(-645.127 -235.47)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_55",
    "data-name": "\\uC120 55",
    x2: 15.926,
    transform: "translate(5.824 16.457)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_56",
    "data-name": "\\uC120 56",
    x2: 10.091,
    transform: "translate(5.824 20.877)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_57",
    "data-name": "\\uC120 57",
    x2: 10.091,
    transform: "translate(5.824 25.298)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_58",
    "data-name": "\\uC120 58",
    x2: 11.682,
    transform: "translate(5.824 29.719)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1480",
    "data-name": "\\uADF8\\uB8F9 1480",
    transform: "translate(17.567 8.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_765",
    "data-name": "\\uD328\\uC2A4 765",
    d: "M666.179,271.358l-5.064.938.938-5.064,16.505-16.505,4.126,4.126Z",
    transform: "translate(-661.115 -250.726)",
    fill: "#fff",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_59",
    "data-name": "\\uC120 59",
    x2: 4.126,
    y2: 4.126,
    transform: "translate(14.712 2.731)",
    fill: "#fff",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_991",
    "data-name": "\\uD328\\uC2A4 991",
    d: "M5488.866-5956.447l5.645,5.645-5.645,5.646",
    transform: "translate(-4658.503 6862.946)",
    fill: "none",
    stroke: "silver",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_992",
    "data-name": "\\uD328\\uC2A4 992",
    d: "M5488.866-5956.447l5.645,5.645-5.645,5.646",
    transform: "translate(-4572.743 6862.946)",
    fill: "none",
    stroke: "silver",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_993",
    "data-name": "\\uD328\\uC2A4 993",
    d: "M5488.866-5956.447l5.645,5.645-5.645,5.646",
    transform: "translate(-4485.04 6862.946)",
    fill: "none",
    stroke: "silver",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_994",
    "data-name": "\\uD328\\uC2A4 994",
    d: "M5488.866-5956.447l5.645,5.645-5.645,5.646",
    transform: "translate(-4399.273 6862.946)",
    fill: "none",
    stroke: "silver",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2023",
    "data-name": "\\uADF8\\uB8F9 2023",
    transform: "translate(1102.251 878)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_197",
    "data-name": "\\uD0C0\\uC6D0 197",
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    transform: "translate(-0.251)",
    fill: "rgba(246,159,48,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2019",
    "data-name": "\\uADF8\\uB8F9 2019",
    transform: "translate(13.101 15.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_1650",
    "data-name": "\\uC0AC\\uAC01\\uD615 1650",
    transform: "translate(-0.352 6.277)",
    fill: "#fff",
    stroke: "#484848",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 29,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 43.5,
    height: 27.5,
    rx: 5.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_198",
    "data-name": "\\uD0C0\\uC6D0 198",
    transform: "translate(7.648 14.277)",
    fill: "#fff",
    stroke: "#484848",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 3.5,
    rx: 4,
    ry: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 3.5,
    rx: 3.25,
    ry: 2.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_199",
    "data-name": "\\uD0C0\\uC6D0 199",
    transform: "translate(5.648 20.277)",
    fill: "#fff",
    stroke: "#484848",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6.5,
    rx: 6,
    ry: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6.5,
    rx: 5.25,
    ry: 5.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1654",
    "data-name": "\\uC0AC\\uAC01\\uD615 1654",
    width: 21,
    height: 7,
    transform: "translate(3.648 26.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_995",
    "data-name": "\\uD328\\uC2A4 995",
    d: "M6354.5-5255h14.829",
    transform: "translate(-6332.486 5271.231)",
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_996",
    "data-name": "\\uD328\\uC2A4 996",
    d: "M6354.5-5255h14.829",
    transform: "translate(-6332.486 5276.101)",
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_997",
    "data-name": "\\uD328\\uC2A4 997",
    d: "M6354.5-5255h14.829",
    transform: "translate(-6332.486 5280.971)",
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_1655",
    "data-name": "\\uC0AC\\uAC01\\uD615 1655",
    transform: "translate(17.648 0.277)",
    fill: "#fff",
    stroke: "#484848",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 7.5,
    height: 8.5,
    fill: "none"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.649072af.svg";
export { ForwardRef as ReactComponent };